<template>
    <form ref="filterForm" class="listing-form">

        <section class="sort-listing">
            <div class="container">
                <div class="wrap">
                    <slot name="sort-listing"></slot>
                    <sort-filter @onSortChanged="handleChange"></sort-filter>
                </div>
            </div>
        </section>

        <slot name="categories"></slot>

        <section class="product-listing">
            <div class="container">
               <div class="listing-wrap">
                   <aside :class="{ block: filterVisible }">
                      <div class="filter-wrap">
                          <div class="close-filter hidden-md-up" @click="closeFilter">
                              {{ closeFilterText }}
                              <span>
                                    <img src="/img/icons/close-2.svg" alt="Zavrieť">
                              </span>
                          </div>

                          <Categories v-if="categories && categories.length"
                                      :title="categoriesTitle"
                                      :main-category="category"
                                      :categories="categories"
                          />

                          <div class="divider" v-if="categories && categories.length"></div>

                          <PriceFilter :title="priceRangeTitle"
                                       :sum="{ min: sum.min, max: sum.max }"
                                       :price-from-label="priceFromLabel"
                                       :price-to-label="priceToLabel"
                                       @onPriceChanged="handleChange"
                          />

                          <div class="divider" v-if="(badges && badges.length) || (brands && brands.length)"></div>

                          <BadgeFilter v-if="badges && badges.length"
                                       :items="badges"
                                       :title="badgeTitle"
                                       @onBadgeChanged="handleChange"
                          />

                          <div class="divider" v-if="badges && badges.length"></div>

                          <BrandFilter v-if="brands && brands.length"
                                       :items="brands"
                                       :title="brandTitle"
                                       :show-more-text="showMoreText"
                                       @onBrandChanged="handleChange"
                          />

                          <div class="divider" v-if="properties && properties.length"></div>

                          <template v-if="properties && properties.length">
                                <PropertyFilter v-for="(property, index) in properties"
                                            :key="index"
                                            :index="index"
                                            :length="properties.length"
                                            :properties="property"
                                            :show-more-text="showMoreText"
                                            @on-property-changed="handleChange"
                            />
                          </template>

                          <div class="cta">
                              <button class="hidden-md-up button primary"
                                      type="button"
                                      @click.prevent="handleChange(1)">
                                  {{ filterText }}
                              </button>
                          </div>
                      </div>
                   </aside>
                   <div class="products-wrap">

                       <div class="filter-toggle hidden-md-up" @click="openFilter">
                           <span v-if="!filterVisible"><img src="/img/icons/filter.svg">{{ showFilterText }}</span>
                           <span v-else><img src="/img/icons/filter.svg">{{ closeFilterText }}</span>
                       </div>

                       <div class="filter-toggle-fixed hidden-md-up"
                            id="js-fixed-filter"
                            @click="openFilter"
                       >
                           <img src="/img/icons/filter.svg" alt="filter">
                       </div>

                       <transition name="fade" appear>
                           <div class="row" v-if="results && results.length">
                               <div class="col-lg-4 col-md-6 column"
                                    v-for="(product, key) in results"
                                    :key="key"
                                    :data-lb-id="product.id"
                                    v-for-callback="{ key: key, array: results, callback: loopCallback }"
                               >
                                   <ThemeProduct :data="product"
                                                 :btn-text="addToCartBtnText"
                                                 :should-add-to-cart="true"
                                   />
                               </div>
                           </div>
                           <div class="row" v-else-if="!loading && !results.length">
                               <div class="col-lg-12">
                                   <p class="text-center">{{ noResultsText }}</p>
                               </div>
                           </div>
                       </transition>

                       <nav class="pagination"
                            v-html="pagination"
                       >
                       </nav>
                   </div>
               </div>
            </div>

            <Loader :visible="loading" />
        </section>
    </form>
</template>

<script>
import { onMounted, inject, ref, watch } from 'vue'

import Categories from '../../widgets/Categories.vue'
import BadgeFilter from '../../filters/BadgeFilter'
import BrandFilter from '../../filters/BrandFilter'
import SortFilter from '../../filters/SortFilter.vue'
import PriceFilter from '../../filters/PriceFilter.vue'
import PropertyFilter from '../../filters/PropertyFilter'
import Product from '../templates/Product-1.vue'
import InfoModal from '../../modals/InfoModal.vue'
import Loader from '../../globals/Loader'
import ThemeProduct from '../templates/ThemeProduct'

import { useFilter } from '../../../composables/useFilter'
import { setElHeight, getFromCategoriesBy } from '../../../functions/helpers'

export default {

    props: [
        'route',
        'categories',
        'category',
        'sum',
        'brands',
        'badges',
        'colors',
        'properties',
        'productsCount',
        'categoriesTitle',
        'addToCartBtnText',
        'addToWishlistBtnText',
        'noResultsText',
        'closeFilterText',
        'filterText',
        'showFilterText',
        'closeFilterText',
        'badgeTitle',
        'brandTitle',
        'priceRangeTitle',
        'priceFromLabel',
        'priceToLabel',
        'showMoreText',
        'gtmDataP'
    ],

    components: {
        Categories,
        BadgeFilter,
        SortFilter,
        PriceFilter,
        PropertyFilter,
        Product,
        InfoModal,
        ThemeProduct,
        Loader,
        BrandFilter
    },

    setup(props) {

        const emitter   = inject('emitter')
        // const constants = inject('constants')
        const gtmData = ref(props.gtmDataP.length ? JSON.parse(props.gtmDataP) : null)

        const {
            filterForm,
            results,
            pagination,
            loading,
            filterVisible,
            handleChange,
            getParamsFromUrl,
            closeFilter,
            openFilter,
        } = useFilter(props.route)

        onMounted( () => {
            loading.value = true

            if (  window.location.href.includes('?')  ) handleFilterData()

            handleUrlParams(getParamsFromUrl())
        })

        function handleFilterData() {
            emitter.emit('set-values-from-parameters', getParamsFromUrl())
        }

        function handleUrlParams(data) {
            setTimeout( () => {
                if ( data.hasOwnProperty('page') )
                    handleChange(data['page'])
                else
                    handleChange(1)
            }, 400)
        }

        function loopCallback() {
            // if ( constants.clientWidth > 767 ) {
                // setElHeight(document.querySelectorAll('.product-listing .product h4'))
                // setElHeight(document.querySelectorAll('.product-listing .product p.excerpt'))
                // setElHeight(document.querySelectorAll('.product-listing .product .description'))
                // setElHeight(document.querySelectorAll('.product-listing .product .bottom'))
            // }
        }

        watch( () => results.value, (value, oldValue, onCleanup) => {
           // console.log(value, oldValue, onCleanup)

            if ( gtmData.value ) {
                value.forEach( (product, index) => {
                    gtmData.value.items.push({
                        'item_id': product.id,
                        'item_name': product.name,
                        'affiliation': 'Eshop',
                        'coupon': '',
                        'discount': product.discount_price,
                        'index': index + 1,
                        'item_brand': product.brand ? product.brand.name : '',
                        'item_category': product.categories ? getFromCategoriesBy(1, product.categories) : '',
                        'item_category2': product.categories ? getFromCategoriesBy(2, product.categories) : '',
                        'item_category3': product.categories ? getFromCategoriesBy(3, product.categories) : '',
                        'item_category4': product.categories ? getFromCategoriesBy(4, product.categories) : '',
                        'item_category5': product.categories ? getFromCategoriesBy(5, product.categories) : '',
                        'item_list_id': '',
                        'item_list_name': '',
                        'item_variant': '',
                        'location_id': '',
                        'price': product.price,
                        'quantity': 1
                    })
                })

                emitter.emit('track-event', { data: gtmData.value, event: 'viewItemList' })
            }
        })

        return {
            filterForm,
            results,
            pagination,
            filterVisible,
            loading,
            handleChange,
            closeFilter,
            openFilter,
            loopCallback
        }
    }
}
</script>
